//
//  Login.tsx
//
//  isana.net,inc. Proprietary and Confidential
//

import { type ReactElement } from "react";
import IsnLogo from "./component/IsnLogo";
import { useCustomAuth } from "./hooks/useCustomAuth";
import { CustomAuthUI } from "./component/CustomAuthUI";

//管理者ログインページ
const Login = (): ReactElement => {
  const { handleSignIn, error: customError } = useCustomAuth();

  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <IsnLogo />
      </div>
      <div>
        <center>
          <p className="middle-space"></p>
          <h1>FITINSIGHT管理者ログイン</h1>
          <CustomAuthUI handleSignIn={handleSignIn} error={customError} />
        </center>
      </div>
    </>
  );
};

export default Login;
